import { render, staticRenderFns } from "./AllPasswords.vue?vue&type=template&id=615385b8&scoped=true"
import script from "./AllPasswords.vue?vue&type=script&lang=js"
export * from "./AllPasswords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615385b8",
  null
  
)

export default component.exports